export const translationsEn = {
  Quantity: 'Quantity',
  Out_of_stock: 'Out of stock',
  Price: 'Price',
  Select: 'Select',
  Cancel: 'Cancel',
  Buy_now: 'Buy now',
  Search: 'Search for product',
  product_not_found: 'Products not found',
  product_category_not_found: 'Products not found',
  Back: 'Back',
  shop_not_found: 'Shop not found'
}



// WEBPACK FOOTER //
// ./src/store/i18n/en.js